<h1 class="welcome-title">Welcome <br />{{ displayName$ | async }}!</h1>
<ng-lottie [options]="options" class="animation"></ng-lottie>
<p>Open an email to <br />get started</p>
